package com.essntl.features.crm.ui.contactorganization

import com.essntl.core.utils.viewmodel.State
import com.essntl.features.crm.domain.model.CreateContactModel

data class ContactOrganizationState(
    val addContactOrganization: State<CreateContactModel> = State(),
)
